import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const categoryData = [
  {
    cat: categories[0],
    isLarge: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20influencer%20scandal%20scene%20with%20dramatic%20spotlight%20on%20silhouette%20warm%20amber%20tones%20mysterious%20atmosphere%20cinematic%20composition%20with%20shadows%20conceptual%20art%20photography&width=800&height=1200&seq=cat-wanghong&orientation=portrait",
  },
  {
    cat: categories[1],
    isLarge: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20celebrity%20downfall%20concept%20with%20shattered%20glamour%20dark%20atmosphere%20warm%20accent%20lighting%20on%20broken%20elements%20cinematic%20noir%20aesthetic%20artistic%20composition&width=800&height=600&seq=cat-mingxing&orientation=landscape",
  },
  {
    cat: categories[2],
    isLarge: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Intense%20breaking%20news%20concept%20with%20dramatic%20lighting%20on%20newspaper%20headlines%20dark%20moody%20atmosphere%20journalistic%20theme%20cinematic%20composition%20warm%20amber%20tones&width=800&height=600&seq=cat-redian&orientation=landscape",
  },
  {
    cat: categories[3],
    isLarge: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Entertainment%20gossip%20atmosphere%20with%20dramatic%20shadows%20of%20people%20whispering%20dark%20moody%20tones%20warm%20accent%20lighting%20cinematic%20style%20conceptual%20photography%20mysterious%20ambiance&width=600&height=400&seq=cat-bagua&orientation=landscape",
  },
  {
    cat: categories[4],
    isLarge: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20video%20camera%20setup%20in%20darkness%20with%20lens%20flare%20and%20moody%20atmosphere%20surveillance%20and%20truth%20concept%20cinematic%20noir%20aesthetic%20warm%20accent%20on%20lens&width=600&height=400&seq=cat-shipin&orientation=landscape",
  },
  {
    cat: categories[5],
    isLarge: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Deep%20investigation%20concept%20with%20magnifying%20glass%20and%20documents%20in%20dramatic%20shadow%20dark%20moody%20atmosphere%20detective%20theme%20cinematic%20composition%20warm%20key%20light&width=600&height=400&seq=cat-shenba&orientation=landscape",
  },
];

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900">
            全网热点 <span className="text-accent-600">深度揭秘</span>
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大分类全覆盖，从网红黑料到明星翻车，第一时间掌握最全爆料资讯
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <Link
            to={`/category/${categoryData[0].cat.slug}`}
            className="relative group rounded-2xl overflow-hidden cursor-pointer md:row-span-2 h-80 md:h-[500px]"
          >
            <img
              src={categoryData[0].imageUrl}
              alt={categoryData[0].cat.name}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              title={`${categoryData[0].cat.name} - ${categoryData[0].cat.description}`}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-foreground-950 text-xs font-semibold mb-2">
                {categoryData[0].cat.name}
              </span>
              <p className="text-background-50/80 text-xs leading-relaxed">{categoryData[0].cat.description}</p>
            </div>
          </Link>

          <div className="flex flex-col gap-4">
            <Link
              to={`/category/${categoryData[1].cat.slug}`}
              className="relative group rounded-2xl overflow-hidden cursor-pointer h-60 md:h-[242px]"
            >
              <img
                src={categoryData[1].imageUrl}
                alt={categoryData[1].cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                title={`${categoryData[1].cat.name} - ${categoryData[1].cat.description}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-foreground-950 text-xs font-semibold mb-2">
                  {categoryData[1].cat.name}
                </span>
                <p className="text-background-50/80 text-xs leading-relaxed">{categoryData[1].cat.description}</p>
              </div>
            </Link>
            <Link
              to={`/category/${categoryData[2].cat.slug}`}
              className="relative group rounded-2xl overflow-hidden cursor-pointer h-60 md:h-[242px]"
            >
              <img
                src={categoryData[2].imageUrl}
                alt={categoryData[2].cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                title={`${categoryData[2].cat.name} - ${categoryData[2].cat.description}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-foreground-950 text-xs font-semibold mb-2">
                  {categoryData[2].cat.name}
                </span>
                <p className="text-background-50/80 text-xs leading-relaxed">{categoryData[2].cat.description}</p>
              </div>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {categoryData.slice(3).map((item, idx) => (
            <Link
              key={item.cat.id}
              to={`/category/${item.cat.slug}`}
              className="relative group rounded-2xl overflow-hidden h-44 md:h-52 cursor-pointer"
            >
              <img
                src={item.imageUrl}
                alt={item.cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                title={`${item.cat.name} - ${item.cat.description}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-foreground-950 text-xs font-semibold">
                  {item.cat.name}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}